import { styled as muiStyled } from '@mui/material';

import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import Typography from '@mui/material/Typography';
import Button from '../Button';

import type { Anchor } from './types';
import { NEW_COLORS } from '../../themes/colors/newColors';

const StyledDrawer = muiStyled(Drawer)(() => ({
  height: 'calc(100vh - 20%)',
  '& .MuiDrawer-paper': {
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    height: 'calc(100vh - 20%)',
  },
}));

const DrawerHeader = muiStyled(Box)(() => ({
  padding: '24px 16px',
  height: '24px',

  display: 'flex',
  gap: '8px',
  alignItems: 'center',
  flexDirection: 'row',
  justifyContent: 'flex-start',

  boxShadow: 'inset 0px -1px 0px rgba(0, 0, 0, 0.16)',
  backgroundColor: NEW_COLORS.BASE.WHITE,
}));

const StyledButton = muiStyled(Button)(() => ({
  padding: 0,
  margin: 0,
  minWidth: '35px',
  width: '35px',
  height: '30px',
}));

const StyledBox = muiStyled(Box)<{ anchor: Anchor }>(({ anchor }) => ({
  width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 653,
  height: '100%',
  background: NEW_COLORS.GRAYSCALE[50],
}));

const Title = muiStyled(Typography)(() => ({
  fontStyle: 'normal',
  fontWeight: 900,
  fontSize: '16px',
  lineHeight: '20px',
}));

export { Title, StyledBox, StyledButton, DrawerHeader, StyledDrawer };
